module.exports = __webpack_public_path__ + "static/media/falling.8e87688d.jpg";